export const AddDocumentInputVariables = [
  "uuid",
  "category",
  "file",
  "label",
  "type",
  "cabinetId",
  "cabinetLabel"
]

export const AddSignatureInputVariables = [
  "label",
  "file"
]

export const AddressFilterInputVariables = [
  "address1",
  "address1__icontains"
]

export const AddressInputVariables = [
  "name",
  "address1",
  "address2",
  "postalCode",
  "city_id",
  "state_id",
  "country_id"
]

export const AppStateInputVariables = [
  "online",
  "debug"
]

export const AssignmentFilterInputVariables = [
  "id",
  "type",
  "type__in"
]

export const AssignmentInputVariables = [
  "id",
  "type",
  "user"
]

export const AttachCompositeInputVariables = [
  "documentUUID",
  "documentVersionId",
  "compositeDocumentUUID",
  "compositeDocumentVersionId"
]

export const BasinFilterInputVariables = [
  "search",
  "name",
  "name__icontains"
]

export const BasinInputVariables = [
  "name"
]

export const BoltInputVariables = [
  "index",
  "torque",
  "torqueLevel",
  "readings"
]

export const CabinetFilterInputVariables = [
  "id",
  "label"
]

export const CabinetInputVariables = [
  "label",
  "category"
]

export const ChangeRecordFilterInputVariables = [
  "outcome",
  "search"
]

export const ChargeFilterInputVariables = [
  "id",
  "showDeleted",
  "showDeletedRequired",
  "item__in",
  "order_by",
  "ticketIn",
  "createdGt",
  "createdLt",
  "modifiedGt",
  "modifiedLt"
]

export const ChargeInputVariables = [
  "id",
  "item",
  "quantity",
  "price",
  "priceRule",
  "note",
  "expectedModified"
]

export const CityFilterInputVariables = [
  "search",
  "name",
  "name__icontains",
  "countyId",
  "stateId",
  "shop",
  "shops"
]

export const CompanyAcquiresWellInputVariables = [
  "company",
  "effectiveDate",
  "wellName"
]

export const CompanyFilterInputVariables = [
  "search",
  "name",
  "name__icontains",
  "ticker",
  "ticker__icontains"
]

export const CompanyInputVariables = [
  "expectedModified",
  "name",
  "number",
  "sigDigitalEnabled",
  "sigImageUpload",
  "sigRemoteEmail",
  "sigStampImageUpload",
  "sigDigitalStamp"
]

export const CompanyRenamesWellInputVariables = [
  "newName",
  "effectiveDate"
]

export const ContentTypeKeysVariables = [
  "appLabel",
  "model"
]

export const ConversionTableFilterInputVariables = [
  "syncedGt"
]

export const ConversionTableInputVariables = [
  "created",
  "modified",
  "deleted",
  "name",
  "inputName",
  "outputName",
  "inverted",
  "clamped",
  "inputMax",
  "inputMin",
  "outputMax",
  "outputMin",
  "points"
]

export const CountryFilterInputVariables = [
  "name",
  "name__icontains"
]

export const CountyFilterInputVariables = [
  "search",
  "name",
  "name__icontains",
  "stateId"
]

export const CreateRunningProcedureInputVariables = [
  "title",
  "description",
  "company"
]

export const CreateServiceTicketInspectionInputVariables = [
  "inspectionId",
  "title",
  "templateKey",
  "templateRevision",
  "templateDefinitionSHA256",
  "schemaVersion",
  "snapshot"
]

export const CustomerInputVariables = [
  "firstName",
  "lastName",
  "email",
  "phoneNumber"
]

export const DeleteRunningProcedureTicketStepResultInputVariables = [
  "id"
]

export const DocIdInputVariables = [
  "id",
  "versionId"
]

export const DocumentFilterInputVariables = [
  "id",
  "uuid",
  "uuidIn",
  "idsIn",
  "type",
  "typeIn",
  "cabinetId",
  "cabinetLabel",
  "cabinetLabelIn",
  "label",
  "label_lookup",
  "label_exclude",
  "label_exclude_lookup"
]

export const EmailTicketInputVariables = [
  "ticketIds",
  "to",
  "subject",
  "body"
]

export const EventFilterInputVariables = [
  "id",
  "id__in",
  "timestamp__gt",
  "timestamp__gte",
  "timestamp__lt",
  "timestamp__lte",
  "public",
  "verb",
  "verbIn",
  "verb__startswith"
]

export const FlangeFilterInputVariables = [
  "syncedGt"
]

export const FlangeInputVariables = [
  "created",
  "modified",
  "deleted",
  "ticket",
  "salesOrder",
  "technician",
  "isBonnet",
  "valveSerial",
  "bonnetConnection",
  "name",
  "number",
  "color",
  "size",
  "rating",
  "wrenchSerial",
  "transducerSerial",
  "bolts"
]

export const FollowFilterInputVariables = [
  "public"
]

export const IntroduceRequiredChargesInputVariables = [
  "charges"
]

export const InventoryItemFilterInputVariables = [
  "order",
  "id",
  "search",
  "number",
  "number__istartswith",
  "description",
  "description__istartswith",
  "description__icontains",
  "longDescription",
  "long_description__istartswith",
  "long_description__icontains",
  "inactive",
  "partType",
  "partTypes",
  "createdGt",
  "createdLt",
  "modifiedGt",
  "modifiedLt"
]

export const InventoryOrderInputVariables = [
  "rank",
  "number",
  "id"
]

export const LimitOffsetInputVariables = [
  "limit",
  "offset"
]

export const NotificationFilterInputVariables = [
  "read"
]

export const PagedInputVariables = [
  "pageSize",
  "page"
]

export const PartTypeFieldInputVariables = [
  "id",
  "index",
  "title",
  "tag",
  "required",
  "fieldType",
  "options"
]

export const PartTypeFieldOptionInputVariables = [
  "id",
  "shortValue",
  "longValue"
]

export const PartTypeFilterInputVariables = [
  "id",
  "name",
  "search",
  "name__icontains",
  "name__istartswith",
  "createdGt",
  "createdLt",
  "modifiedGt",
  "modifiedLt"
]

export const PartTypeInputVariables = [
  "name",
  "description",
  "numberFormat",
  "numberPrefix",
  "createProducts",
  "trackRevision",
  "trackSerial",
  "partTemplate",
  "productTemplate",
  "fields",
  "engineers"
]

export const PinnedRunningProcedureVersionInputVariables = [
  "runningProcedureId",
  "number",
  "documentUuid",
  "documentVersionId"
]

export const PressureEvidenceDescriptorInputVariables = [
  "schemaVersion",
  "mediaType",
  "contentEncoding",
  "transportSHA256",
  "contentSHA256",
  "compressedByteCount",
  "uncompressedByteCount",
  "channelCount",
  "gapCount",
  "sampleCount"
]

export const PressureEvidenceRecordingInputVariables = [
  "created",
  "modified",
  "clientRecordingId",
  "signatureState",
  "signedAt",
  "signedBy",
  "technicianSignature",
  "ticket",
  "salesOrder",
  "tester",
  "startTime",
  "stopTime",
  "transducerSerial",
  "type",
  "wellColor",
  "msMarker",
  "duration",
  "startPsi",
  "stopPsi",
  "testName",
  "holdDurationMinutes",
  "selectedWindowStartMs",
  "selectedWindowEndMs",
  "blowByTolerancePsi",
  "maxDropPercent",
  "technicianNotes",
  "bleedOffCompletedAtMs",
  "bleedOffBaselinePsi",
  "transducerAssignments",
  "transducerCalibrationSnapshots",
  "passFailResults",
  "telemetryGaps"
]

export const PressureReadingInputVariables = [
  "ms",
  "psi",
  "channelKey"
]

export const PressureRecordingFilterInputVariables = [
  "syncedGt"
]

export const PressureRecordingInputVariables = [
  "created",
  "modified",
  "deleted",
  "clientRecordingId",
  "signatureState",
  "signedAt",
  "signedBy",
  "technicianSignature",
  "signature",
  "revisionNumber",
  "supersedesRecordingId",
  "signedPayloadHash",
  "ticket",
  "salesOrder",
  "tester",
  "startTime",
  "stopTime",
  "transducerSerial",
  "type",
  "wellColor",
  "msMarker",
  "duration",
  "startPsi",
  "stopPsi",
  "testName",
  "holdDurationMinutes",
  "selectedWindowStartMs",
  "selectedWindowEndMs",
  "blowByTolerancePsi",
  "maxDropPercent",
  "technicianNotes",
  "bleedOffCompletedAtMs",
  "bleedOffBaselinePsi",
  "transducerAssignments",
  "transducerCalibrationSnapshots",
  "passFailResults",
  "telemetryGaps",
  "readings"
]

export const PressureRecordingSignoffInputVariables = [
  "signatureState",
  "signedAt",
  "technicianSignature"
]

export const PressureTelemetryGapInputVariables = [
  "channelKey",
  "startMs",
  "endMs"
]

export const PressureTransducerCalibrationRecordFilterInputVariables = [
  "syncedGt",
  "transducer",
  "transducerSerial"
]

export const PressureTransducerCalibrationRecordInputVariables = [
  "created",
  "modified",
  "deleted",
  "transducer",
  "transducerSerial",
  "calibratedBy",
  "calibratedAt",
  "signedAt",
  "technicianSignature",
  "referenceEquipment",
  "zeroOffsetPsi",
  "maxCalibrationPsi",
  "conversionTable",
  "conversionTableSnapshot",
  "verificationResults",
  "notes"
]

export const PressureTransducerFilterInputVariables = [
  "syncedGt"
]

export const PressureTransducerInputVariables = [
  "created",
  "modified",
  "deleted",
  "name",
  "label",
  "displayColorId",
  "serialNumber",
  "deviceUUID",
  "dataRateMax",
  "dataRateMin",
  "psiMax",
  "psiMin",
  "conversionTable"
]

export const PriceRuleFilterInputVariables = [
  "productId",
  "companyId",
  "companyIn",
  "createdGt",
  "createdLt",
  "modifiedGt",
  "modifiedLt"
]

export const PublishStandaloneInspectionInputVariables = [
  "inspectionId",
  "title",
  "templateKey",
  "templateRevision",
  "templateDefinitionSHA256",
  "schemaVersion",
  "snapshot",
  "evidenceReceipts"
]

export const RejectSignatureResponseInputVariables = [
  "signatoryName",
  "signatoryEmail",
  "rejectReason"
]

export const RequiredChargeInputVariables = [
  "item",
  "quantity",
  "order"
]

export const ReservePressureRecordingEvidenceInputVariables = [
  "clientMutationId",
  "clientEvidenceRevision",
  "recording",
  "evidence"
]

export const ReserveRunningProcedureStepEvidenceInputVariables = [
  "stepId",
  "clientMutationId",
  "targetEvidenceId",
  "expectedRevision",
  "caption",
  "position",
  "capturedOn"
]

export const ReserveTorqueRecordingEvidenceInputVariables = [
  "clientMutationId",
  "clientEvidenceRevision",
  "recording",
  "evidence"
]

export const RunningProcedureFilterInputVariables = [
  "id",
  "search",
  "title",
  "title__istartswith",
  "title__icontains",
  "description",
  "description__istartswith",
  "description__icontains",
  "company",
  "companies",
  "createdGt",
  "createdLt",
  "modifiedGt",
  "modifiedLt"
]

export const RunningProcedureRevisionInputVariables = [
  "versionId",
  "steps",
  "requiredCharges"
]

export const RunningProcedureStepInputVariables = [
  "id",
  "title",
  "order",
  "fieldType",
  "description",
  "pageNumber",
  "required"
]

export const RunningProcedureTicketStepResultInputVariables = [
  "id",
  "runningProcedureStepId",
  "data",
  "attribute",
  "completedOn"
]

export const RunningProcedureTicketStepResultRevisionInputVariables = [
  "id",
  "runningProcedureStepId",
  "data",
  "attribute",
  "completedOn",
  "expectedRevision",
  "clientMutationId"
]

export const RunningProcedureVersionInputVariables = [
  "runningProcedureId",
  "number"
]

export const SalesOrderFilterInputVariables = [
  "id",
  "search",
  "excludeTickets",
  "order",
  "status",
  "statuses",
  "statusChangedDateGt",
  "statusChangedDateLt",
  "erpClass",
  "erpClass_istartswith",
  "erpClass_icontains",
  "erpStatus",
  "erpStatuses",
  "number",
  "number__istartswith",
  "number__icontains",
  "createdGt",
  "createdLt",
  "modifiedGt",
  "modifiedLt",
  "issuedGt",
  "issuedLt",
  "scheduledGte",
  "scheduledLte",
  "company",
  "companies",
  "shipToNameIcontains",
  "salesman",
  "salesmen",
  "signatureState",
  "signatureStates",
  "signatureStateChangedGt",
  "signatureStateChangedLt"
]

export const SalesOrderOrderInputVariables = [
  "number",
  "status",
  "statusChangedDate",
  "ERPStatus",
  "signatureState",
  "signatureStateChangedDate",
  "issuedDate",
  "scheduledDate",
  "modified",
  "created"
]

export const ServiceTicketFieldWorkInputVariables = [
  "startTime",
  "arrivedTime",
  "departedTime",
  "jsaPerformedTime",
  "endTime",
  "workPerformed",
  "afeNumber",
  "jobCode",
  "salesOrderNumber"
]

export const ServiceTicketInputVariables = [
  "id",
  "number",
  "salesOrderNumber",
  "type",
  "phase",
  "wellId",
  "accountManager",
  "company",
  "companyMan",
  "companyManPhone",
  "companyManEmail",
  "procedureRevisionId",
  "workRequestDate",
  "scheduledArrivalTime",
  "rigName",
  "crewName",
  "jobDescription",
  "spareParts",
  "technicians",
  "arriveToShop",
  "shopLocation",
  "dispatchNotes",
  "startTime",
  "arrivedTime",
  "departedTime",
  "jsaPerformedTime",
  "endTime",
  "workPerformed",
  "afeNumber",
  "jobCode"
]

export const SignatureRequestInputVariables = [
  "signatoryName",
  "signatoryEmail",
  "documentUUID",
  "documentVersionId",
  "message"
]

export const SignatureResponseFilterInputVariables = [
  "createdGt",
  "createdLt",
  "modifiedGt",
  "modifiedLt",
  "type"
]

export const SignatureResponseInputVariables = [
  "signatoryName",
  "signatoryEmail",
  "type",
  "emailCustomer",
  "documentUUID",
  "documentVersionId"
]

export const StateFilterInputVariables = [
  "name",
  "name__icontains"
]

export const ThumbnailInputVariables = [
  "width",
  "height"
]

export const TicketFilterInputVariables = [
  "order",
  "id",
  "search",
  "number",
  "number__istartswith",
  "number__icontains",
  "ticketType",
  "status",
  "statusIn",
  "assignment",
  "createdGt",
  "createdLt",
  "modifiedGt",
  "modifiedLt",
  "startGt",
  "startLt",
  "company",
  "companies",
  "well",
  "wells",
  "procedure",
  "procedures",
  "rigName",
  "rigName_istartswith",
  "rigName_icontains",
  "customer",
  "owners",
  "creators",
  "assigned",
  "sales",
  "lead_technicians",
  "technicians",
  "signatureState",
  "signatureStates",
  "signatureStateChangedGt",
  "signatureStateChangedLt"
]

export const TicketOrderInputVariables = [
  "number",
  "status",
  "type",
  "scheduledArrivalTime",
  "signatureState",
  "modified",
  "created"
]

export const TimeSheetEntryFilterInputVariables = [
  "syncedGt"
]

export const TimeSheetEntryInputVariables = [
  "created",
  "modified",
  "deleted",
  "ticket",
  "user",
  "date",
  "hours",
  "perDiem",
  "entryType",
  "shopLocation",
  "notes"
]

export const TorqueEvidenceDescriptorInputVariables = [
  "schemaVersion",
  "mediaType",
  "contentEncoding",
  "transportSHA256",
  "contentSHA256",
  "compressedByteCount",
  "uncompressedByteCount",
  "boltResultCount",
  "attemptCount",
  "sampleCount"
]

export const TorqueEvidenceRecordingInputVariables = [
  "created",
  "modified",
  "clientRecordingId",
  "signatureState",
  "signedAt",
  "signedBy",
  "technicianSignature",
  "ticket",
  "salesOrder",
  "tester",
  "flange",
  "startTime",
  "stopTime",
  "testName",
  "flangeName",
  "flangeSize",
  "flangeRating",
  "wrenchSerial",
  "transducerSerial",
  "targetTorqueFtLb",
  "completedBoltCount",
  "totalBoltCount",
  "technicianNotes",
  "setupSnapshot",
  "transducerCalibrationSnapshot",
  "torqueConversionSnapshot"
]

export const TorqueRecordingFilterInputVariables = [
  "syncedGt"
]

export const TorqueRecordingInputVariables = [
  "created",
  "modified",
  "deleted",
  "clientRecordingId",
  "signatureState",
  "signedAt",
  "signedBy",
  "technicianSignature",
  "ticket",
  "salesOrder",
  "tester",
  "flange",
  "startTime",
  "stopTime",
  "testName",
  "flangeName",
  "flangeSize",
  "flangeRating",
  "wrenchSerial",
  "transducerSerial",
  "targetTorqueFtLb",
  "completedBoltCount",
  "totalBoltCount",
  "technicianNotes",
  "setupSnapshot",
  "transducerCalibrationSnapshot",
  "torqueConversionSnapshot",
  "evidenceSnapshot",
  "boltResults",
  "graphSamples"
]

export const TorqueWrenchFilterInputVariables = [
  "syncedGt"
]

export const TorqueWrenchInputVariables = [
  "created",
  "modified",
  "deleted",
  "serialNumber",
  "modelNumber",
  "torquewareId",
  "manufacturer",
  "calibrationDate",
  "expirationDate",
  "conversionTable"
]

export const TransducerAssignmentInputVariables = [
  "transducerSerial",
  "transducerId",
  "deviceUUID",
  "channelKey",
  "role",
  "cavityLabel",
  "testingNote",
  "targetPsi",
  "acceptanceUnit",
  "acceptanceValue",
  "calibrationRecordId",
  "calibratedAt",
  "zeroOffsetPsi",
  "maxCalibrationPsi"
]

export const TransducerPassFailResultInputVariables = [
  "transducerSerial",
  "transducerId",
  "role",
  "failureReason",
  "failureValue",
  "maxPsi",
  "minPsi",
  "dropPercent",
  "passed",
  "windowDurationMs",
  "risePsi",
  "baselinePsi"
]

export const UpdateRunningProcedureInputVariables = [
  "description",
  "company"
]

export const UserFilterInputVariables = [
  "order",
  "id",
  "search",
  "group",
  "groupId",
  "createdGt",
  "createdLt",
  "modifiedGt",
  "modifiedLt",
  "company",
  "companies"
]

export const UserOrderInputVariables = [
  "modified",
  "created"
]

export const UserSettingsInputVariables = [
  "darkModeSet",
  "darkMode"
]

export const WellDetailInputVariables = [
  "apiNumber",
  "city",
  "basin",
  "latitude",
  "longitude",
  "directions"
]

export const WellFilterInputVariables = [
  "search",
  "name",
  "name__icontains",
  "companyId",
  "createdGt",
  "createdLt",
  "modifiedGt",
  "modifiedLt"
]

export const WellInputVariables = [
  "id",
  "name",
  "company",
  "apiNumber",
  "city",
  "basin",
  "latitude",
  "longitude",
  "directions"
]

export const WellRenameInputVariables = [
  "newName"
]
